var map = {
	"./bokeh1.jpg": 23577,
	"./bokeh2.jpg": 97411,
	"./pattern1.png": 69624,
	"./pattern10.png": 7807,
	"./pattern11.png": 77499,
	"./pattern12.png": 6110,
	"./pattern2.png": 19159,
	"./pattern3.png": 95952,
	"./pattern4.png": 84551,
	"./pattern5.png": 32675,
	"./pattern6.png": 11655,
	"./pattern7.png": 4872,
	"./pattern8.png": 34374,
	"./pattern9.png": 98323,
	"./photo1.jpg": 1599,
	"./photo2.jpg": 40883,
	"./photo3.jpg": 99748,
	"./photo4.jpg": 3857,
	"./photo5.jpg": 3557,
	"./photo6.jpg": 95542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84345;